import {
  IAddEditGoalsAssessment,
  IAddPersonalSmartGoals,
  IPersonalSmartGoalsRequest,
  IUpdateHopesGoalsAndAmbitions,
  IWhereToFromHere,
} from "utils/interfaces/slp-form";
import baseService from "services/base-service";
import { SLPFormStep } from "utils/enums/slp-form";

const slpBaseUrl = `/api/SLP`;

const geHopesGoalsAndAmbitions = async (payload: {
  slpId: number;
  partNumber: SLPFormStep;
}) =>
  baseService.get(
    `${slpBaseUrl}/GetSLPForm/?slpId=${payload.slpId}&partNumber=${payload.partNumber}`
  );

const updateHopesGoalsAndAmbitions = async (
  payload: IUpdateHopesGoalsAndAmbitions
) => baseService.put(`${slpBaseUrl}/EditHopesGoalsAmbitions`, payload);

const addPersonalAndSmartGoals = async (payload: IAddPersonalSmartGoals) =>
  baseService.post(`${slpBaseUrl}/AddSlpPersonalSmartGoals`, payload);

const addEditGoalsAssessment = async (payload: IAddEditGoalsAssessment) =>
  baseService.post(`${slpBaseUrl}/AddEditSlpGoalAssessment`, payload);

const deletePersonalAndSmartGoals = async (payload: { id: number }) =>
  baseService.delete(
    `${slpBaseUrl}/DeleteSlpPersonalSmartGoals/?id=${payload.id}`
  );

const getAllPersonalAndSmartGoals = async (
  payload: IPersonalSmartGoalsRequest
) => baseService.post(`${slpBaseUrl}/GetAllSlpPersonalSmartGoals`, payload);

const getPersonalAndSmartGoalsBySlpId = async (
  payload: IPersonalSmartGoalsRequest
) => baseService.post(`${slpBaseUrl}/GetSlpPersonalSmartGoalsBySlpId`, payload);

const getCurrentSLPGoalsPDF = async (payload: IPersonalSmartGoalsRequest) =>
  baseService.post(`${slpBaseUrl}/GetCurrentSLPGoalsPDf`, payload);

const addWhereToFromHere = async (payload: IWhereToFromHere) =>
  baseService.post(`${slpBaseUrl}/AddWhereToFromHere`, payload);

export default {
  geHopesGoalsAndAmbitions,
  updateHopesGoalsAndAmbitions,
  addPersonalAndSmartGoals,
  addEditGoalsAssessment,
  deletePersonalAndSmartGoals,
  getAllPersonalAndSmartGoals,
  getPersonalAndSmartGoalsBySlpId,
  getCurrentSLPGoalsPDF,
  addWhereToFromHere,
};
